import ErrorIcon from '@mui/icons-material/Error';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from 'components/Modal/Modal';
import React from 'react';

const ErrorModal = ({ message, onClose }) => {
  return (
    <Modal open fullWidth disablePortal title="Error!" onClose={onClose}>
      <Box>
        <ErrorIcon color="error" />
      </Box>
      <Typography>{message}</Typography>
    </Modal>
  );
};

export default ErrorModal;
